<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <v-overlay :value="!dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <strong color="#871B12" class="pa-5">รายงานการลา</strong>

        <v-row class="pa-2">
          <v-col cols="6">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
               <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                prepend-inner-icon="mdi-map-marker-radius"
                class="ma-2"
            ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                hide-details
                prepend-inner-icon="mdi-map-marker"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                hide-details
                prepend-inner-icon="mdi-briefcase"
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>

          <v-col cols="6">
            <v-sheet tile height="54" class="d-flex">
              <!-- ประเภทการลา -->
              <v-select
                v-model="leaveType"
                :items="itemsLeaveTypeSelect"
                dense
                outlined
                hide-details
                label="ประเภทลา"
                  clearable
              clear-icon="mdi-close-circle"
                class="ma-2"
              ></v-select>
              <!-- วัน -->
              <!-- <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="วัน"
                class="ma-2"
              ></v-select> -->
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <v-btn
                class="ml-5 mt-2"
                color="#173053"
                dark
                @click="getData()"
              >
                <v-icon left size="20"
                  >mdi-calendar-search</v-icon
                >
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-expansion-panels
      v-model="panel"
      multiple
    >
      <v-expansion-panel>
        <v-expansion-panel-header>ภาพรวมประจำปี</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-col cols="12">
              <v-card rounded="xl">
                <v-card-title class="text-h6">
                  <v-icon left> mdi-chart-bar </v-icon>
                  ประเภทการลา ภาพรวมประจำปี
                </v-card-title>
                <canvas class="pa-5" id="myChartDataTotal"></canvas>
              </v-card>
              </v-col>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>ภาพรวมสาขา</v-expansion-panel-header>
        <v-expansion-panel-content>
          Some content
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>สำนักงานใหญ่</v-expansion-panel-header>
        <v-expansion-panel-content>
          Some content
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>สาขาบางกอกน้อย</v-expansion-panel-header>
        <v-expansion-panel-content>
          Some content
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>สาขาหนองแขม</v-expansion-panel-header>
        <v-expansion-panel-content>
          Some content
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>สาขาปากเกร็ด - เมืองทอง</v-expansion-panel-header>
        <v-expansion-panel-content>
          Some content
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>สาขาแจ้งวัฒนะ</v-expansion-panel-header>
        <v-expansion-panel-content>
          Some content
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>House Development</v-expansion-panel-header>
        <v-expansion-panel-content>
          Some content
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

          <v-col cols="6">
            <v-card rounded="xl">
              <v-card-title class="text-h6">
                <v-icon left> mdi-chart-bar </v-icon>
                ประเภทการลา ภาพรวม
              </v-card-title>
              <canvas class="pa-5" id="myChartLeave"></canvas>
            </v-card>
          </v-col>
          <v-col cols="12">
          <v-card elevation="7" v-if="dataReady">
            <v-dialog v-model="dialogView" persistent max-width="80%">
                    <v-card>
                      <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialogView = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title
                        >ข้อมูลพนักงานลา <br>
                        [{{empCode}} {{empFull_NameTH}}]
                        [{{masDepartmentName}}] [{{masBranchName}}] [{{masCompanyName}}]</v-toolbar-title
                        >
                      </v-toolbar>
                      <v-row class="pa-2 ma-2">
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              class="pb-2 pt-2 ma-2 mb-2"
              rounded="xl"
              elevation="5"
            >
              <v-row class="pb-0 pt-3 pl-5 ">
                <v-col class="pb-0 pt-3 pl-5 ">
                  <p class="font-weight-black">ลาพักร้อน</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row class="pl-0 pb-0">
                  <v-col class="pb-0 pt-0 text-h5 text-center">{{vacationLeave}} / 6</v-col>
                  <p class="pt-8 pr-2 pb-0 font-weight-black">ครั้ง</p>
                </v-row>
              </v-card-text>
            </v-card>
            </v-col>
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              class="pa-2 ma-2 mb-2"
              rounded="xl"
              elevation="5"
            >
              <v-row class="pb-0 pt-3 pl-5 ">
                <v-col class="pb-0 pt-3 pl-5 ">
                  <p class="font-weight-black">ลาป่วย</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row  class="pb-0 pt-0 ">
                  <v-col class="pb-0 pt-0 text-h5 text-center">{{sickLeave}} / 30</v-col>
                  <p class="pt-8 pr-2 pb-0 pt-0 font-weight-black">ครั้ง</p>
                </v-row>
              </v-card-text>
            </v-card>
            </v-col>
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              class="pa-2 ma-2 mb-2"
              rounded="xl"
              elevation="5"
            >
              <v-row class="pb-0 pt-3 pl-5 ">
                <v-col class="pb-0 pt-3 pl-5 ">
                  <p class="font-weight-black">ลากิจ</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row  class="pb-0 pt-0 ">
                  <v-col class="pb-0 pt-0 text-h5 text-center">{{personalLeave}} / 4</v-col>
                  <p class="pt-8 pr-2 pb-0 pt-0 font-weight-black">ครั้ง</p>
                </v-row>
              </v-card-text>
            </v-card>
            </v-col>
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              class="pa-2 ma-2 mb-2"
              rounded="xl"
              elevation="5"
            >
              <v-row class="pb-0 pt-3 pl-5 ">
                <v-col class="pb-0 pt-3 pl-5 ">
                  <p class="font-weight-black">ลาอุปสมบท</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row  class="pb-0 pt-0 ">
                  <v-col class="pb-0 pt-0 text-h5 text-center">{{ordinationLeave}} / 7</v-col>
                  <p class="pt-8 pr-2 pb-0 pt-0 font-weight-black">ครั้ง</p>
                </v-row>
              </v-card-text>
            </v-card>
            </v-col>
          <v-col
            elevation="10"
            cols="2"
          >
            <v-card
              class="pa-2 ma-2 mb-2"
              rounded="xl"
              elevation="5"
            >
              <v-row class="pb-0 pt-3 pl-5 ">
                <v-col class="pb-0 pt-3 pl-5 ">
                  <p class="font-weight-black">ลาคลอด</p>
                </v-col>
              </v-row>

              <v-card-text>
                <v-row  class="pb-0 pt-0 ">
                  <v-col class="pb-0 pt-0 text-h5 text-center">{{maternityLeave}} / 98</v-col>
                  <p class="pt-8 pr-2 pb-0 pt-0 font-weight-black">ครั้ง</p>
                </v-row>
              </v-card-text>
            </v-card>
            </v-col>
                      </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-card-title>
                        <v-text-field
                          v-model="searchInfoByMonth"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-data-table
                            :headers="columnsSelect"
                            :items="dataItemByMonth"
                            :search="searchInfoByMonth"
                            :items-per-page="10"
                          >
                          </v-data-table>
                        </v-container>
                      </v-card-text>
                    </v-col>

                  </v-row>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          elevation="2"
                          x-large
                          color="dark darken-1"
                          text
                          @click="dialogView = false"
                        >
                          <v-icon left> mdi-cancel</v-icon>
                          ปิด
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
            <v-card-text>
              <v-data-table
                :headers="columnTotall"
                :items="dataItemLeave"
                :search="searchAll2"
                :items-per-page="5"
              >
              <template v-slot:[`item.action`]="{ item }">
                <v-icon dark color="#4A148C" @click.stop="dialogView = true, getDataShift(item)"> mdi-eye </v-icon>
              </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          </v-col>

        <v-divider class="mx-4"></v-divider>
        <v-row class="pa-5">
          <v-col cols="6">
            <v-card rounded="xl">
              <v-card-title class="text-h6">
                <v-icon left> mdi-chart-bar </v-icon>
                ประเภทการลา รออนุมัติ
              </v-card-title>
              <canvas class="pa-5" id="myChartWaiting"></canvas>
            </v-card>
          </v-col>
          <v-col cols="12">
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columns"
                :items="dataItemLeaveWaiting"
                :search="searchAll2"
                :items-per-page="5"
              >
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                     <v-btn
                    color="warning"
                    fab
                    small
                    dark
                    v-if="item.leaveEmergency ==='True'"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
        <v-row class="pa-5">
          <v-col cols="6">
            <v-card rounded="xl">
              <v-card-title class="text-h6">
                <v-icon left> mdi-chart-bar </v-icon>
                ประเภทการลา อนุมัติ
              </v-card-title>
              <canvas class="pa-5" id="myChartApprove"></canvas>
            </v-card>
          </v-col>
          <v-col cols="12">
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columns"
                :items="dataItemApprove"
                :search="searchAll2"
                :items-per-page="5"
              >
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                     <v-btn
                    color="warning"
                    fab
                    small
                    dark
                    v-if="item.leaveEmergency ==='True'"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
        <v-row class="pa-5">
          <v-col cols="6">
            <v-card rounded="xl">
              <v-card-title class="text-h6">
                <v-icon left> mdi-chart-bar </v-icon>
                ประเภทการลา ไม่อนุมัติ
              </v-card-title>
              <canvas class="pa-5" id="myChartUnApprove"></canvas>
            </v-card>
          </v-col>
          <v-col cols="12">
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columns"
                :items="dataItemUnApprove"
                :search="searchAll2"
                :items-per-page="5"
              >
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                     <v-btn
                    color="warning"
                    fab
                    small
                    dark
                    v-if="item.leaveEmergency ==='True'"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
        <v-row class="pa-5">
          <v-col cols="6">
            <v-card rounded="xl">
              <v-card-title class="text-h6">
                <v-icon left> mdi-chart-bar </v-icon>
                ประเภทการลา ยกเลิก
              </v-card-title>
              <canvas class="pa-5" id="myChartCancel"></canvas>
            </v-card>
          </v-col>
          <v-col cols="12">
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columns"
                :items="dataItemCancel"
                :search="searchAll2"
                :items-per-page="5"
              >
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                     <v-btn
                    color="warning"
                    fab
                    small
                    dark
                    v-if="item.leaveEmergency ==='True'"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
          <v-row>
        <v-col cols="6">
                <v-card rounded="xl">
                  <v-card-title class="text-h6">
                    <v-icon left> mdi-chart-bar </v-icon>
                    ประเภทการลา ภาพรวมรายปี สำนักงานใหญ่
                  </v-card-title>
                  <canvas class="pa-5" id="myChartLeaveHO"></canvas>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card rounded="xl">
                  <v-card-title class="text-h6">
                    <v-icon left> mdi-chart-bar </v-icon>
                    ประเภทการลา ภาพรวมรายปี สาขาบางกอกน้อย
                  </v-card-title>
                  <canvas class="pa-5" id="myChartLeaveBKN"></canvas>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card rounded="xl">
                  <v-card-title class="text-h6">
                    <v-icon left> mdi-chart-bar </v-icon>
                    ประเภทการลา ภาพรวมรายปี สาขาหนองแขม
                  </v-card-title>
                  <canvas class="pa-5" id="myChartLeaveNK"></canvas>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card rounded="xl">
                  <v-card-title class="text-h6">
                    <v-icon left> mdi-chart-bar </v-icon>
                    ประเภทการลา ภาพรวมรายปี สาขาปากเกร็ด - เมืองทอง
                  </v-card-title>
                  <canvas class="pa-5" id="myChartLeavePKM"></canvas>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card rounded="xl">
                  <v-card-title class="text-h6">
                    <v-icon left> mdi-chart-bar </v-icon>
                    ประเภทการลา ภาพรวมรายปี สาขาแจ้งวัฒนะ
                  </v-card-title>
                  <canvas class="pa-5" id="myChartLeaveCW"></canvas>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card rounded="xl">
                  <v-card-title class="text-h6">
                    <v-icon left> mdi-chart-bar </v-icon>
                    ประเภทการลา ภาพรวมรายปี House Development
                  </v-card-title>
                  <canvas class="pa-5" id="myChartLeaveHD"></canvas>
                </v-card>
              </v-col>
          </v-row>

      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
import dayName from '../../assets/master/Date/day.json'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
import { gmapApi } from 'vue2-google-maps'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    apexchart: VueApexCharts,
    moment,
    gmapApi
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  data () {
    return {
      PK: '',
      center: {},
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงานลา',
          disabled: false,
          href: '/Dashbord/DashbordLeave'
        }
      ],
      panel: [0],
      dialog: false,
      dialogView: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      searchAll2: '',
      loader: null,
      loading3: false,
      date: new Date().toISOString().substr(0, 10),
      // Data Table Config
      columnTotall: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ประเภท', value: 'quotaLeaveName' },
        { text: 'ตั้งแต่', value: 'leaveStartDate' },
        { text: 'ถึง', value: 'leaveEndDate' },
        { text: 'จำนวน', value: 'leaveSummaryDay' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'ดูรายการทั้งหมด', value: 'action', sortable: false, align: 'center' }
      ],
      columnsSelect: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ประเภท', value: 'quotaLeaveName' },
        { text: 'ตั้งแต่', value: 'leaveStartDate' },
        { text: 'ถึง', value: 'leaveEndDate' },
        { text: 'จำนวน', value: 'leaveSummaryDay' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'หัวหน้า', value: 'empFull_NameTH_approve' }
      ],
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ประเภท', value: 'quotaLeaveName' },
        { text: 'ตั้งแต่', value: 'leaveStartDate' },
        { text: 'ถึง', value: 'leaveEndDate' },
        { text: 'จำนวน', value: 'leaveSummaryDay' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'ลาด่วน', value: 'leaveEmergency' },
        { text: 'หัวหน้า', value: 'empFull_NameTH_approve' }
      ],
      dataItemByMonth: [],
      searchInfoByMonth: '',
      dataItemLeave: [], // รวม
      dataItemLeaveWaiting: [], // รออนุมัติ
      dataItemApprove: [], // อนุมัติ
      dataItemUnApprove: [], // ไม่อนุมัติ
      dataItemCancel: [], // ยกเลิก
      BranchItem: [], // สาขา
      Branch: '', // สาขา
      DepartmentItem: [], // แผนก
      Department: '', // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      itemsLeaveTypeSelect: [],
      leaveType: '',
      disableSearch: false,
      empCode: '',
      empFull_NameTH: '',
      masBranchName: '',
      masDepartmentName: '',
      masCompanyName: '',
      year: '',
      month: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      leaveEmergencyCount: 0, // ลาด่วน
      personalLeave: 0, // ลากิจ
      sickLeave: 0, // ลาป่วย
      vacationLeave: 0, // ลาพักร้อน
      ordinationLeave: 0, // ลาบวช
      maternityLeave: 0 // ลาคลอด
    }
  },
  async mounted () {
    await this.getGetToken()
    this.dataReady = false

    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
    await this.getDataLeaveType()
    await this.getData()
  },
  methods: {
    async getData () {
      await this.getDataCountLeave()
      await this.getDataCountLeaveApprove()
      await this.getDataCountLeaveWaiting()
      await this.getDataCountLeaveUnApprove()
      await this.getDataCountLeaveCancel()
      await this.getDataLeaveBranchPKM()
      await this.getDataLeaveBranchBKN()
      await this.getDataLeaveBranchCW()
      await this.getDataLeaveBranchNK()
      await this.getDataLeaveBranchHO()
      await this.getDataLeaveBranchHD()
    },
    async getDataCountLeave () {
      this.dataReady = false
      this.dataItemLeave = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.year = (this.year) ? this.year : null
      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_data/get' +
          '?leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemLeave = response.data
          this.dataItemLeave.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount = this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeave()
      await this.CharJSCheckDataTotal()
    },
    async getDataCountLeaveApprove () {
      this.dataReady = false
      this.dataItemApprove = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_data/get?leaveStatus=approve' +
          '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemApprove = response.data
          this.dataItemApprove.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount = this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveApprove()
    },
    async getDataCountLeaveWaiting () {
      this.dataReady = false
      this.dataItemLeaveWaiting = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_data/get?leaveStatus=waiting' +
          '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemLeaveWaiting = response.data
          this.dataItemLeaveWaiting.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount = this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveWaiting()
    },
    async getDataCountLeaveUnApprove () {
      this.dataReady = false
      this.dataItemUnApprove = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_data/get?leaveStatus=unapprove' +
           '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemUnApprove = response.data
          this.dataItemUnApprove.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount = this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveUnApprove()
    },
    async getDataCountLeaveCancel () {
      this.dataReady = false
      this.dataItemCancel = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null
      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_data/get?leaveStatus=cancel' +
           '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemCancel = response.data
          this.dataItemCancel.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount = this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveCancel()
    },
    async getDataLeaveBranchPKM () {
      this.dataReady = false
      this.dataItemLeave = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = this.leaveType ? this.leaveType : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : null
      this.Department = this.Department ? this.Department : null
      // this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var leaveTypeSerch =
        this.leaveType !== null ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch =
        this.month !== null
          ? '&leaveStartMonth=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      // var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/get' +
            '?leaveStartYear=' +
            this.year +
            monthSearch +
            leaveTypeSerch +
            Company +
            '&masBranchName=สาขาปากเกร็ด - เมืองทอง' +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemLeave = response.data
          this.dataItemLeave.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount =
        this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveBranchPKM()
    },
    async CharJSCheckLeaveBranchPKM () {
      var ctx = document.getElementById('myChartLeavePKM')
      var myChartLeavePKM = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            {
              label: 'จำนวนการลา',
              data: [
                this.personalLeave,
                this.sickLeave,
                this.vacationLeave,
                this.ordinationLeave,
                this.maternityLeave
              ],
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) {
            console.log('onclick', d, i)
          }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartLeavePKM)
    },
    async getDataLeaveBranchBKN () {
      this.dataReady = false
      this.dataItemLeave = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = this.leaveType ? this.leaveType : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : null
      this.Department = this.Department ? this.Department : null
      // this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var leaveTypeSerch =
        this.leaveType !== null ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch =
        this.month !== null
          ? '&leaveStartMonth=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      // var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/get' +
            '?leaveStartYear=' +
            this.year +
            monthSearch +
            leaveTypeSerch +
            Company +
            '&masBranchName=สาขาบางกอกน้อย' +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemLeave = response.data
          this.dataItemLeave.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount =
        this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveBranchBKN()
    },
    async CharJSCheckLeaveBranchBKN () {
      var ctx = document.getElementById('myChartLeaveBKN')
      var myChartLeaveBKN = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            {
              label: 'จำนวนการลา',
              data: [
                this.personalLeave,
                this.sickLeave,
                this.vacationLeave,
                this.ordinationLeave,
                this.maternityLeave
              ],
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) {
            console.log('onclick', d, i)
          }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartLeaveBKN)
    },
    async getDataLeaveBranchCW () {
      this.dataReady = false
      this.dataItemLeave = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = this.leaveType ? this.leaveType : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : null
      this.Department = this.Department ? this.Department : null
      // this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var leaveTypeSerch =
        this.leaveType !== null ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch =
        this.month !== null
          ? '&leaveStartMonth=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      // var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/get' +
            '?leaveStartYear=' +
            this.year +
            monthSearch +
            leaveTypeSerch +
            Company +
            '&masBranchName=สาขาแจ้งวัฒนะ' +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemLeave = response.data
          this.dataItemLeave.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount =
        this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveBranchCW()
    },
    async CharJSCheckLeaveBranchCW () {
      var ctx = document.getElementById('myChartLeaveCW')
      var myChartLeaveCW = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            {
              label: 'จำนวนการลา',
              data: [
                this.personalLeave,
                this.sickLeave,
                this.vacationLeave,
                this.ordinationLeave,
                this.maternityLeave
              ],
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) {
            console.log('onclick', d, i)
          }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartLeaveCW)
    },
    async getDataLeaveBranchNK () {
      this.dataReady = false
      this.dataItemLeave = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = this.leaveType ? this.leaveType : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : null
      this.Department = this.Department ? this.Department : null
      // this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var leaveTypeSerch =
        this.leaveType !== null ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch =
        this.month !== null
          ? '&leaveStartMonth=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      // var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/get' +
            '?leaveStartYear=' +
            this.year +
            monthSearch +
            leaveTypeSerch +
            Company +
            '&masBranchName=สาขาหนองแขม' +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemLeave = response.data
          this.dataItemLeave.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount =
        this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveBranchNK()
    },
    async CharJSCheckLeaveBranchNK () {
      var ctx = document.getElementById('myChartLeaveNK')
      var myChartLeaveNK = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            {
              label: 'จำนวนการลา',
              data: [
                this.personalLeave,
                this.sickLeave,
                this.vacationLeave,
                this.ordinationLeave,
                this.maternityLeave
              ],
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) {
            console.log('onclick', d, i)
          }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartLeaveNK)
    },
    async getDataLeaveBranchHO () {
      this.dataReady = false
      this.dataItemLeave = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = this.leaveType ? this.leaveType : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : null
      this.Department = this.Department ? this.Department : null
      // this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var leaveTypeSerch =
        this.leaveType !== null ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch =
        this.month !== null
          ? '&leaveStartMonth=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      // var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/get' +
            '?leaveStartYear=' +
            this.year +
            monthSearch +
            leaveTypeSerch +
            Company +
            '&masBranchName=สำนักงานใหญ่' +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemLeave = response.data
          this.dataItemLeave.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount =
        this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveBranchHO()
    },
    async CharJSCheckLeaveBranchHO () {
      var ctx = document.getElementById('myChartLeaveHO')
      var myChartLeaveHO = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            {
              label: 'จำนวนการลา',
              data: [
                this.personalLeave,
                this.sickLeave,
                this.vacationLeave,
                this.ordinationLeave,
                this.maternityLeave
              ],
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) {
            console.log('onclick', d, i)
          }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartLeaveHO)
    },
    async getDataLeaveBranchHD () {
      this.dataReady = false
      this.dataItemLeave = []
      this.leaveEmergencyCount = 0
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.leaveType = this.leaveType ? this.leaveType : null
      this.month = this.month ? this.month : null
      this.year = this.year ? this.year : null
      this.Department = this.Department ? this.Department : null
      // this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var leaveTypeSerch =
        this.leaveType !== null ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch =
        this.month !== null
          ? '&leaveStartMonth=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      // var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/get' +
            '?leaveStartYear=' +
            this.year +
            monthSearch +
            leaveTypeSerch +
            Company +
            '&masBranchName=House Development' +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemLeave = response.data
          this.dataItemLeave.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
            if (leaveItem.leaveEmergency === 'True') {
              this.leaveEmergencyCount += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })

      console.log('ลากิจ', this.personalLeave)
      console.log('ลาป่วย', this.sickLeave)
      console.log('ลาพักร้อน', this.vacationLeave)
      console.log('ลาบวช', this.ordinationLeave)
      console.log('ลาคลอด', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)

      this.leaveEmergencyCount =
        this.leaveEmergencyCount < 0 ? 0 : this.leaveEmergencyCount
      this.personalLeave = this.personalLeave < 0 ? 0 : this.personalLeave
      this.sickLeave = this.sickLeave < 0 ? 0 : this.sickLeave
      this.vacationLeave = this.vacationLeave < 0 ? 0 : this.vacationLeave
      this.ordinationLeave = this.ordinationLeave < 0 ? 0 : this.ordinationLeave
      this.maternityLeave = this.maternityLeave < 0 ? 0 : this.maternityLeave
      await this.CharJSCheckLeaveBranchHD()
    },
    async CharJSCheckLeaveBranchHD () {
      var ctx = document.getElementById('myChartLeaveHD')
      var myChartLeaveHD = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            {
              label: 'จำนวนการลา',
              data: [
                this.personalLeave,
                this.sickLeave,
                this.vacationLeave,
                this.ordinationLeave,
                this.maternityLeave
              ],
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) {
            console.log('onclick', d, i)
          }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartLeaveHD)
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_company/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_branch/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_department/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    async getDataLeaveType () {
      console.log('getDataLeaveType1111', this.$session.getAll().data.positionTypeCode)
      // Clear Data ทุกครั้ง
      this.itemsLeaveTypeSelect = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_quota/' +
            'get?positionTypeCode=' + this.$session.getAll().data.positionTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          console.log('getDataLeaveType222', rs)
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.quotaLeaveName
            s.value = d.quotaLeaveCode
            d = s
            this.itemsLeaveTypeSelect.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async CharJSCheckLeave () {
      // personalLeave: 0, // ลากิจ
      // sickLeave: 0, // ลาป่วย
      // vacationLeave: 0, // ลาพักร้อน
      // ordinationLeave: 0, // ลาบวช
      // maternityLeave: 0 // ลาคลอด
      console.log('personalLeave', this.personalLeave)
      console.log('sickLeave', this.sickLeave)
      console.log('vacationLeave', this.vacationLeave)
      console.log('ordinationLeave', this.ordinationLeave)
      console.log('maternityLeave', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)
      // let _this = this
      var ctx = document.getElementById('myChartLeave')
      var myChartLeave = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            // {
            //   label: 'ประเภทลาฉุกเฉิน',
            //   type: 'line',
            //   data: [0, 10, 102, 2, 2],
            //   backgroundColor: 'rgba(54,73,93,.5)',
            //   borderColor: '#36495d',
            //   borderWidth: 3
            // },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave, this.ordinationLeave, this.maternityLeave],
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) { console.log('onclick', d, i) }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartLeave)
    },
    async CharJSCheckLeaveApprove () {
      // personalLeave: 0, // ลากิจ
      // sickLeave: 0, // ลาป่วย
      // vacationLeave: 0, // ลาพักร้อน
      // ordinationLeave: 0, // ลาบวช
      // maternityLeave: 0 // ลาคลอด
      console.log('personalLeave', this.personalLeave)
      console.log('sickLeave', this.sickLeave)
      console.log('vacationLeave', this.vacationLeave)
      console.log('ordinationLeave', this.ordinationLeave)
      console.log('maternityLeave', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)
      // let _this = this
      var ctx = document.getElementById('myChartApprove')
      var myChartApprove = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            // {
            //   label: 'ประเภทลาฉุกเฉิน',
            //   type: 'line',
            //   data: [0, 10, 102, 2, 2],
            //   backgroundColor: 'rgba(54,73,93,.5)',
            //   borderColor: '#36495d',
            //   borderWidth: 3
            // },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave, this.ordinationLeave, this.maternityLeave],
              backgroundColor: '#00897B',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) { console.log('onclick', d, i) }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartApprove)
    },
    async CharJSCheckLeaveWaiting () {
      var ctx = document.getElementById('myChartWaiting')
      var myChartWaiting = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            // {
            //   label: 'ประเภทลาฉุกเฉิน',
            //   type: 'line',
            //   data: [0, 10, 102, 2, 2],
            //   backgroundColor: 'rgba(54,73,93,.5)',
            //   borderColor: '#36495d',
            //   borderWidth: 3
            // },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave, this.ordinationLeave, this.maternityLeave],
              backgroundColor: 'orange',
              borderWidth: 3
            }
          ],
          onclick: function () { alert('hello world!') }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log('myChartWaiting', myChartWaiting)
    },
    async CharJSCheckDataTotal () {
      var ctx = document.getElementById('myChartDataTotal')
      var myChartDataTotal = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August ', 'September ', 'October ', 'November ', 'December'],
          datasets: [
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave],
              backgroundColor: 'orange',
              borderWidth: 3
            },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave],
              backgroundColor: 'orange',
              borderWidth: 3
            },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave],
              backgroundColor: 'orange',
              borderWidth: 3
            },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave],
              backgroundColor: 'orange',
              borderWidth: 3
            },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave],
              backgroundColor: 'orange',
              borderWidth: 3
            }
          ],
          onclick: function () { alert('hello world!') }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log('myChartDataTotal', myChartDataTotal)
    },
    async CharJSCheckLeaveUnApprove () {
      // personalLeave: 0, // ลากิจ
      // sickLeave: 0, // ลาป่วย
      // vacationLeave: 0, // ลาพักร้อน
      // ordinationLeave: 0, // ลาบวช
      // maternityLeave: 0 // ลาคลอด
      console.log('personalLeave', this.personalLeave)
      console.log('sickLeave', this.sickLeave)
      console.log('vacationLeave', this.vacationLeave)
      console.log('ordinationLeave', this.ordinationLeave)
      console.log('maternityLeave', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)
      // let _this = this
      var ctx = document.getElementById('myChartUnApprove')
      var myChartUnApprove = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            // {
            //   label: 'ประเภทลาฉุกเฉิน',
            //   type: 'line',
            //   data: [0, 10, 102, 2, 2],
            //   backgroundColor: 'rgba(54,73,93,.5)',
            //   borderColor: '#36495d',
            //   borderWidth: 3
            // },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave, this.ordinationLeave, this.maternityLeave],
              backgroundColor: 'red',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) { console.log('onclick', d, i) }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartUnApprove)
    },
    async CharJSCheckLeaveCancel () {
      // personalLeave: 0, // ลากิจ
      // sickLeave: 0, // ลาป่วย
      // vacationLeave: 0, // ลาพักร้อน
      // ordinationLeave: 0, // ลาบวช
      // maternityLeave: 0 // ลาคลอด
      console.log('personalLeave', this.personalLeave)
      console.log('sickLeave', this.sickLeave)
      console.log('vacationLeave', this.vacationLeave)
      console.log('ordinationLeave', this.ordinationLeave)
      console.log('maternityLeave', this.maternityLeave)
      console.log('leaveEmergencyCount', this.leaveEmergencyCount)
      // let _this = this
      var ctx = document.getElementById('myChartCancel')
      var myChartCancel = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['ลากิจ', 'ลาป่วย', 'ลาพักร้อน', 'ลาอุปสมบท', 'ลาคลอด'],
          datasets: [
            // {
            //   label: 'ประเภทลาฉุกเฉิน',
            //   type: 'line',
            //   data: [0, 10, 102, 2, 2],
            //   backgroundColor: 'rgba(54,73,93,.5)',
            //   borderColor: '#36495d',
            //   borderWidth: 3
            // },
            {
              label: 'จำนวนการลา',
              data: [this.personalLeave, this.sickLeave, this.vacationLeave, this.ordinationLeave, this.maternityLeave],
              backgroundColor: '#757575',
              borderWidth: 3
            }
          ],
          onclick: function (d, i) { console.log('onclick', d, i) }
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartCancel)
    },
    async getDataShift (item) {
      this.dataItemByMonth = []
      this.empCode = ''
      this.empFull_NameTH = ''
      this.masBranchName = ''
      this.masDepartmentName = ''
      this.masCompanyName = ''
      this.personalLeave = 0
      this.sickLeave = 0
      this.vacationLeave = 0
      this.ordinationLeave = 0
      this.maternityLeave = 0

      this.month = (this.month) ? this.month : null
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_data/' + 'get?empCode=' + item.empCode + monthSearch,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log(response.data)
          // this.dataReady = true
          this.dataItemByMonth = response.data
          this.dataItemByMonth.forEach(leaveItem => {
            if (leaveItem.quotaLeaveName === 'ลากิจ') {
              this.personalLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาป่วย') {
              this.sickLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาพักร้อน') {
              this.vacationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาบวช') {
              this.ordinationLeave += 1
            }
            if (leaveItem.quotaLeaveName === 'ลาคลอด') {
              this.maternityLeave += 1
            }
          })
          console.log('ลากิจQQ', this.personalLeave)
          console.log('ลาป่วยQQ', this.sickLeave)
          console.log('ลาพักร้อนQQ', this.vacationLeave)
          console.log('ลาบวชQQ', this.ordinationLeave)
          console.log('ลาคลอดQQ', this.maternityLeave)
          this.empCode = response.data[0].empCode
          this.empFull_NameTH = response.data[0].empFull_NameTH
          this.masBranchName = response.data[0].masBranchName
          this.masDepartmentName = response.data[0].masDepartmentName
          this.masCompanyName = response.data[0].masCompanyName
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.dataReady = true
        })
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #262A34;
}
.Color-Font {
  color: #808588;
}
.Color-Font-Action {
  color: #b61c1c;
}
.Color-Font-Preview {
  color: #262a34;
}
.Color-Button {
  color: #b61c1c;
}
.Divider {
  border: 2px solid #808588;
  background: #808588;
  border-radius: 5px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashbord/DashbordLeave.vue